import { getList } from "@/api/baseApi";

/**
 * 数据源配置数据提供者（Vuex 模块）
 *
 * @author PeterLee
 * @since 2025-05-11
 */
const state = {
    sourceOptions: [],
    loading: false
}

export default {
    namespaced: true,
    state,
    getters: {},
    mutations: {
        setSourceOptions(state, options) {
            state.sourceOptions = options
        },
        setLoading(state, loading) {
            state.loading = loading
        }
    },
    actions: {
        /** 加载数据源下拉选项 */
        async loadSourceOptions({ commit }) {
            try {
                const res = await getList('data', 'source');
                commit('setSourceOptions', res.data || []);
                return res.data || [];
            } catch (error) {
                console.error('加载数据源列表失败:', error);
                return [];
            }
        },
        /** 加载所有数据库列表（用于回显和级联） */
        async loadDatabases() {
            try {
                const res = await getList('data', 'dataBase');
                return res.data || [];
            } catch (error) {
                console.error('加载数据库列表失败:', error);
                return [];
            }
        }
    },
    modules: {}
}
